/**
 * Runs `send` after the save before it (review fix: two saves never run at once, so their answers
 * cannot come back out of order). A failed save before it does not stop this one, and this one never
 * rejects: `send` handles its own errors. Pure apart from `send`.
 */
export function chainCoverSave(previous: Promise<void>, send: () => Promise<void>): Promise<void> {
  return previous.catch(() => undefined).then(send);
}
